import popOverFactory from 'common/components/core/popover/popOverFactory';
import Dropzone from './Dropzone';

const DropzoneWithPopover = popOverFactory({
    withObserverFlag: true,
    Component: Dropzone
});

export default DropzoneWithPopover;
